import {
	Component,
	ElementRef,
	Input,
	OnChanges, OnDestroy,
	OnInit,
	SimpleChanges,
	ViewChild,
} from '@angular/core';
import {CarouselService,ShareDataService} from "@signature-it/ngx-generic/services";
import {GalleryConfigDTO} from "@signature-it/ngx-generic/models";
import {EntityConfig} from "@signature-it/ngx-generic/config";
import { EntityService} from '@signature-it/ngx-entity/services';
import { CarouselLayout } from '@signature-it/ngx-entity/enums';
import {take} from "rxjs/operators";
import {LanguageService} from '@signature-it/ngx-generic/services';
import {ILanguage} from "@signature-it/ngx-generic/interfaces";


declare let _ : any;

@Component({
    selector: 'ngx-custom-preview-carousel',
    templateUrl: './custom-preview-carousel.component.html',
    styleUrls: ['./custom-preview-carousel.component.scss'],
    standalone: false
})
export class PreviewCarouselComponentGeneric implements OnInit, OnDestroy, OnChanges {

	@Input() key: string = 'default';
	@Input() api: string;
	@Input() fieldCollectionVar: string;
	@Input() carouselItemsWidth: string = 'auto';
	@Input() carouselWidth: string = 'auto';
	@Input() showCarouselButtons: boolean;
	@Input() showPlayButton: boolean;
	@Input() autoPlay: boolean = true;
	@Input() entityPreviewVar: string;
	@Input() dependSelector: any = '';

	items: [];
	Math;
	libraryIndex = 0;
	carouselId: string;
	responsive: object;
	gridInfo: object = {};
    entityConfig;
	templates;
	template: string = '';
	intervalId;
	carouselLayout;
	itemsPerRow;
	itemsPerPage;
	CarouselLayout = CarouselLayout;

    @ViewChild('altCarouselContainer') altCarouselContainer: ElementRef;


	constructor(protected carouselService: CarouselService,
				protected entiyService: EntityService,
				public sharedSvc: ShareDataService,
				protected langSvc: LanguageService) {
		 this.Math = Math;
     }


	ngOnInit() {
		this.sharedSvc.hideDependElements(this.dependSelector);
		this.init();
		this.getEntityTypeBody();
	}

	init() {
		let config;
		if(EntityConfig.ngxCustomPreviewCarousel) {
			config = EntityConfig.ngxCustomPreviewCarousel[this.key];
		}
		this.setConfig(config);
		if(this.api) {
			this.carouselService.getDataFromApi(this.api).subscribe((items: []) => {
				if(items && items.length) {
					this.items = items;
					this.libraryIndex = Math.round(this.items.length / 2 - 1);
					this.sharedSvc.showDependElements(this.dependSelector);
				}
				if (this.carouselLayout != this.CarouselLayout.FLAT && this.autoPlay) this.startPlay();
			});
			this.carouselId = `carousel-${Date.now()}`;
		}
	}
	ngOnDestroy() {
		this.stopPlay();
	}

	startPlay() {
		console.log(this.items.length);
		if (!this.intervalId) {
			let sidelang = 'left'
			this.langSvc.getCurrentLanguage$().pipe(take(2)).subscribe((lang: ILanguage) => {
				if (lang.code === 'en') {
					sidelang ='right';
				}
				this.intervalId = setInterval(() => {
					this.scrollAltCarousel(sidelang, true);
				}, this.entityConfig.autoplaySpeed || 5000);
			});

		} else {
			this.stopPlay();
		}
	}

	stopPlay() {
		if (this.intervalId) {
			clearInterval(this.intervalId);
			this.intervalId = null;
		}
	}

	getCardTemplate(previewVar) {
		if(!this.templates) return;
		return this.templates[previewVar];
	}

	getEntityTypeBody() {
		this.entiyService.getEntityPreviews().subscribe(items => {
			this.templates = items || {};
			this.template = this.templates[this.entityPreviewVar];
		})
	}

	ngOnChanges(changes: SimpleChanges) {
     	if(changes.api && !changes.api.firstChange) {
     		this.init();
		}
	}

	getGridInfo() {
		const screenWidth =  window.innerWidth;
		let responsiveKey = Object.keys(this.responsive).reduce(
			(prev, curr) =>
				(Number(screenWidth) - Number(curr)  <  Number(screenWidth) - Number(prev))
				&& Number(curr) < Number(screenWidth)? curr : prev )
		return this.responsive[responsiveKey];
	}


    getGridInfoByConfigBp(){
        let responsiveKeys = _.keys(this.responsive);
     	const currentKey = this.sharedSvc.getCurrentBp(responsiveKeys);
     	return this.responsive[currentKey];
	}

	setConfig(config) {

		const configOptions = GalleryConfigDTO.create(config);
		this.entityConfig = config;

        this.responsive = configOptions?.responsive;
        if(!this.responsive) {
            this.gridInfo =  {};
        } else {
            this.gridInfo =  isNaN(+Object.keys(this.responsive)[0]) ? this.getGridInfoByConfigBp() : this.getGridInfo();
        }
		this.entityPreviewVar = this.entityPreviewVar || this.gridInfo['entity-preview-var'] || config['entity-preview-var'];
        this.carouselWidth = this.gridInfo['carouselWidth'] || config?.carouselWidth || this.carouselWidth;
        this.carouselItemsWidth = this.gridInfo['carouselItemsWidth'] || config?.carouselItemsWidth || this.carouselItemsWidth;
        // set showCarouselButtons
        if(typeof this.gridInfo['showCarouselButtons'] !== 'undefined'){
            this.showCarouselButtons = this.gridInfo['showCarouselButtons'];
        } else if(typeof config?.showCarouselButtons !== 'undefined'){
            this.showCarouselButtons = config?.showCarouselButtons;
        } else {
            this.showCarouselButtons = true;
        }
		// set showPlayButton
        if(typeof this.gridInfo['showPlayButton'] !== 'undefined'){
            this.showPlayButton = this.gridInfo['showPlayButton'];
        } else if(typeof config?.showPlayButton !== 'undefined'){
            this.showPlayButton = config?.showPlayButton;
        } else {
            this.showPlayButton = true;
        }
		// autoPlay
		if(typeof this.gridInfo['autoPlay'] !== 'undefined'){
			this.autoPlay = this.gridInfo['autoPlay'];
		} else if(typeof config?.autoPlay !== 'undefined'){
			this.autoPlay = config?.autoPlay;
		} else {
			this.autoPlay = true;
		}
		this.carouselLayout = config?.carouselLayout || '';
		this.itemsPerRow = this.gridInfo['itemsPerRow'] || config?.itemsPerRow || 1;
		this.itemsPerPage = config?.itemsPerPage || 12;
		this.addMoreData(configOptions);
    }

	addMoreData(configOptions) {
		this.api = this.api || this.gridInfo['api'] || configOptions?.api;
	}

    scrollAltCarousel(side: string, auto: boolean = false){
     	if(this.entityConfig){
			let slideItems;
			 if (auto) {
				 slideItems = this.entityConfig.autoSlideItems ? this.entityConfig.autoSlideItems : 1;
			 } else {
				 slideItems = this.entityConfig.slideItems ? this.entityConfig.slideItems : 1;
			 }
     		let itemWidth = this.carouselItemsWidth == 'auto' ? this.altCarouselContainer.nativeElement.firstChild.offsetWidth: parseInt(this.carouselItemsWidth, 10);
     		if (side == 'right'){
                this.altCarouselContainer.nativeElement.scrollLeft += (itemWidth * slideItems);
            } else if (side == 'left'){
                this.altCarouselContainer.nativeElement.scrollLeft -= (itemWidth * slideItems);
            } else {
     			return;
			}
        } else {
     		return;
		}
    }

}
